import React from 'react';
import PropTypes from 'prop-types';
import { Modal, connectModal } from '@gsa/afp-component-library';
import AddMakeModelContent from './add-make-model-content';
import { MakeModelPanelProvider } from '../Providers/make-model-panel-provider';

const MakeModelAddModal = ({ isOpen, onClose, refetchData }) => {
  const modalTitle = 'Add make and model';

  return (
    <Modal
      id="make-model-add-modal"
      variant="large"
      title={
        <h2 tabIndex="0" aria-label={modalTitle}>
          {modalTitle}
        </h2>
      }
      onClose={onClose}
      isOpen={isOpen}
    >
      <MakeModelPanelProvider context="VMSVR">
        <AddMakeModelContent onClose={onClose} refetchData={refetchData} />
      </MakeModelPanelProvider>
    </Modal>
  );
};

MakeModelAddModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  refetchData: PropTypes.func.isRequired,
};

const MakeModelAddConnectModal = connectModal(MakeModelAddModal);

export default MakeModelAddConnectModal;
